import { TrackingEngine as ITrackingEngine } from 'components-machine';
import { AnswerTrackerData, Config } from 'schema';
import type { Question } from 'schema/poll';
import { questionReplaceUnsafe, replaceUnsafeInput } from './pixel/unsafe';

abstract class TrackingEngine implements ITrackingEngine {
  abstract questionsMapping: Record<string, Config>;

  async questionReplaceUnsafeInput(
    question: { data: { type: string } },
    text: string | undefined,
  ): Promise<string | undefined> {
    if (text === undefined) return undefined;
    return questionReplaceUnsafe(question as Question) ? replaceUnsafeInput(text) : text;
  }

  questionTracker(question: { data: { type: string } }): (trackingData: AnswerTrackerData) => AnswerTrackerData {
    const questionConfig = this.questionsMapping[question.data.type];
    const defaultTracker = (trackingData: AnswerTrackerData) => trackingData;
    if (questionConfig?.tracker) return questionConfig.tracker(question);
    return defaultTracker;
  }
}

export default TrackingEngine;
